export enum UserRoles {
  user =  'user',
  gpanel = 'gpanel'
}
